import { ReactNode } from 'react'

import {
  Tag as ChakraTag,
  TagLabel,
  TagLabelProps,
  TagProps as ChakraTagProps,
} from '@chakra-ui/react'

interface TagProps extends ChakraTagProps {
  label: string
  labelProps?: TagLabelProps
  color?: TagLabelProps['color']
  background?: ChakraTagProps['background']
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  height?: string
}

export const Tag = ({
  label,
  labelProps,
  color,
  background = 'brand.wildBlueYonder',
  height = '20px',
  leftIcon,
  rightIcon,
  ...rest
}: TagProps) => (
  <ChakraTag borderRadius="md" h={height} bg={background} {...rest}>
    {leftIcon && leftIcon}
    <TagLabel
      fontFamily="Proxima Nova Semibold"
      fontSize="13px"
      color={color}
      {...labelProps}
      my="0px"
    >
      {label}
    </TagLabel>
    {rightIcon && rightIcon}
  </ChakraTag>
)
